import React from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import LoginPage from '../components/LoginPage.js';
import HeadBar from '../components/HeadBar.js';
import HomePage from '../components/HomePage.js';
import NewEvent from '../components/NewEvent.js';
import ReserveBox from '../components/ReserveBox.js';
import AddParticipants from '../components/AddParticipants.js';
import Payment from '../components/Payment.js';
import NewUser from '../components/NewUser.js';
import Contact from '../info/Contact.js';
import ViewUsers from '../components/ViewUsers.js';
import SignupPage from '../components/SignupPage.js';
import TogetherPage from '../components/TogetherPage.js';
import EventList from '../components/EventList.js';
import ForgotPassword from '../components/ForgotPassword.js';
import ChangePassword from '../components/ChangePassword.js';
import MyAccount from '../components/MyAccount.js';
import MyProfile from '../components/MyProfile.js';
import EventInvitees from '../components/EventInvitees';
import PrivacyPolicy from '../info/PrivacyPolicy.js';
import CookiePolicy from '../info/CookiePolicy.js';
import TermsOfService from '../info/TermsOfService.js';
import EmailOptOut from '../info/EmailOptOut.js';
import ViewEvent from '../components/ViewEvent.js';
import PrivateRoute from './PrivateRoute.js';
import HostAdminRoute from './HostAdminRoute.js';
import AdminRoute from './AdminRoute.js';
import SpecialRoute from './SpecialRoute.js';
import StreamSkeleton from '../ui/viewEventUi/StreamSkeleton.js';
import ShareEventContainer from '../components/ShareEventContainer.js';
import RedirectToLogin from './RedirectToLogin.js';
import EmailList from '../ui/emailList/EmailList';
// import PaymentStripe from '../components/PaymentStripe.js';
import BookingPreview from '../components/BookingPreview.js';
import AccountVerified from '../components/AccountVerified.js';
import ResetPassword from '../components/ResetPassword.js';
import EmailVerifySuccess from '../components/EmailVerifySuccess.js';
import ContactInfo from '../components/ContactInfo.js';

function Routes() {
  const location = useLocation();

  return (
    <Switch location={location} key={location.key}>
      {/* <PrivateRoute exact path="/together" component={TogetherPage} /> */}
      <SpecialRoute exact path='/together' component={TogetherPage} />
      <Route exact path='/privacypolicy' component={PrivacyPolicy} />
      <Route exact path='/termsofservice' component={TermsOfService} />
      <Route exact path='/cookiepolicy' component={CookiePolicy} />
      <Route exact path='/streamskeleton' component={StreamSkeleton} />
      <Route exact path='/verify/:token' component={EmailVerifySuccess} />

      <>
        <HeadBar />
        <Route exact path='/contactinfo' component={ContactInfo} />
        <Route exact path='/accountverified' component={AccountVerified} />
        <RedirectToLogin exact path='/login' component={LoginPage} />
        <HostAdminRoute exact path='/emaillist' component={EmailList} />
        <Route exact path='/signup' component={SignupPage} />
        <Route exact path='/payment' component={Payment} />
        <Route exact path='/contact' component={Contact} />
        <Route exact path='/forgotpassword' component={ForgotPassword} />
        <Route
          exact
          path='/password/:pageType/:token'
          component={ResetPassword}
        />
        <Route exact path='/unsubscribe/:userId' component={EmailOptOut} />
        <Route
          exact
          path='/event/share/:eventId/:eventUniqueNo'
          // component={SharedEventPage}
          component={ShareEventContainer}
        />
        <Route
          exact
          path='/event/load/:eventId/:eventUniqueNo'
          // component={InvitedEventPage}
          component={ShareEventContainer}
        />
        <AdminRoute exact path='/newuser' component={NewUser} />
        <AdminRoute exact path='/viewusers' component={ViewUsers} />
        <HostAdminRoute exact path='/newevent' component={NewEvent} />
        <HostAdminRoute exact path='/eventinvitees' component={EventInvitees} />
        <HostAdminRoute exact path='/viewevent' component={ViewEvent} />
        <PrivateRoute exact path='/' component={EventList} />
        <PrivateRoute exact path='/homepage' component={HomePage} />
        <PrivateRoute exact path='/reservebox' component={ReserveBox} />
        <PrivateRoute
          exact
          path='/addparticipants'
          component={AddParticipants}
        />
        <PrivateRoute exact path='/changepassword' component={ChangePassword} />
        <PrivateRoute exact path='/myprofile' component={MyProfile} />
        <PrivateRoute exact path='/myaccount' component={MyAccount} />
        <PrivateRoute exact path='/bookingpreview' component={BookingPreview} />
        {/* <PrivateRoute exact path='/paymentstripe' component={PaymentStripe} /> */}
      </>
    </Switch>
  );
}

export default Routes;
